import { render, staticRenderFns } from "./t2_drag.vue?vue&type=template&id=9ecb0396&scoped=true&"
import script from "./t2_drag.vue?vue&type=script&lang=js&"
export * from "./t2_drag.vue?vue&type=script&lang=js&"
import style0 from "./t2_drag.vue?vue&type=style&index=0&id=9ecb0396&prod&lang=scss&"
import style1 from "./t2_drag.vue?vue&type=style&index=1&id=9ecb0396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb0396",
  null
  
)

export default component.exports